const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || '';
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '';

const safeTenantId = tenantId || 'common';
const safeClientId = clientId || '00000000-0000-0000-0000-000000000000';

export const isAuthConfigured = Boolean(tenantId && clientId);

const apiScope = clientId ? `api://${clientId}/access_as_user` : null;

export const msalConfig = {
  auth: {
    clientId: safeClientId,
    authority: `https://login.microsoftonline.com/${safeTenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

// Request scopes for team-based access control.
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', ...(apiScope ? [apiScope] : [])],
};

// Team access is driven by App Roles, surfaced in the token's `roles` claim.
// This replaces the former `groups` claim, which carries every security group
// a user belongs to and is dropped entirely by Azure AD once a user exceeds
// ~200 groups (group overage) - silently breaking access. App Roles are scoped
// to this application only, so the token stays small and stable.
//
// Azure AD setup (App Registration):
//   1. App roles: define one role per team. The role Value MUST match a key in
//      the backend GROUP_TO_TEAMS_MAPPING, e.g. iCOP.IES.Access, iCOP.DMI.Access,
//      iCOP.FLCAD.Access, iCOP.FSU.Team.Access, iCOP.MyKONE-Delivery.Access,
//      iCOP.Admin.Access, iCOP.SAP.Access, iCOP.Security.Access, ...
//   2. Enterprise application > Users and groups: assign each access group to
//      its matching App Role.
// The `roles` claim is emitted automatically for assigned App Roles; no token-
// configuration optional-claim entry is needed. MSAL.js does not shape claims
// from the SPA - this block documents the required directory setup.
export const optionalClaims = {
  idToken: [
    {
      name: 'roles',
      source: null,
      essential: false,
      additionalProperties: []
    }
  ],
  accessToken: [
    {
      name: 'roles',
      source: null,
      essential: false,
      additionalProperties: []
    }
  ]
};
